var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckinWithPinDarkHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10556_11",
    "data-name": "Group 10556 11",
    transform: "translate(-140 -1010)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6850",
    "data-name": "Rectangle 6850",
    width: 40,
    height: 40,
    rx: 5,
    ry: 5,
    transform: "translate(140 1010)",
    fill: "#24435f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Scanner",
    transform: "translate(145.5 1020)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_29",
    "data-name": "Subtraction 29",
    d: "M14728-14793h-24a3,3,0,0,1-3-3v-14a3,3,0,0,1,3-3h24a3,3,0,0,1,3,3v14A3,3,0,0,1,14728-14793Zm-4.971-8.513v0l.854,1.512,1.3-.759-.859-1.51h1.722v-1.513h-1.722l.859-1.458-1.3-.762-.854,1.465-.866-1.465-1.312.762.859,1.458H14720v1.513h1.714l-.859,1.511,1.313.757.865-1.512Zm-6.944,0v0l.857,1.512,1.313-.759-.866-1.51h1.722v-1.513h-1.722l.866-1.458-1.312-.762-.858,1.465-.855-1.465-1.315.762.854,1.458h-1.706v1.513h1.706l-.854,1.511,1.315.757.854-1.511Zm-7.06,0v0l.854,1.512,1.3-.759-.855-1.51h1.718v-1.513h-1.718l.855-1.458-1.3-.762-.854,1.465-.862-1.465-1.312.762.858,1.458H14706v1.513h1.714l-.858,1.511,1.313.757.861-1.512Z",
    transform: "translate(-14701.001 14813)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckinWithPinDarkHover);
export default __webpack_public_path__ + "static/media/CheckinWithPinDarkHover.8abc766dc62035149fece0a67b61180e.svg";
export { ForwardRef as ReactComponent };